/**
 * 画面のスクロール位置
 */
export class WindowPosition {
    /* 画面のスクロール位置 */
    scrollX = 0
    scrollY = 0

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<WindowPosition>) {
        Object.assign(this, init)
    }

    /**
     * 現在の画面のスクロール位置を取得する
     */
    public static now() {
        return new WindowPosition({scrollX: window.scrollX, scrollY: window.scrollY})
    }
}
